import {connect} from 'react-redux';

import {batch} from '../../../../../../../../../src/helpers/reduxHelpers';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../../src/helpers/reselectHelpers';
import {jobDeletedAction} from '../../../../../../../../../src/store/data/jobs/jobsActions';
import {getAccountsImportJobs} from '../../../../../../../../../src/store/data/jobs/jobsSelectors';
import {toggleShouldDisplayImportCSVInfoBannerAction} from '../../../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {getShouldDisplayImportAccountsCSVInfoBanner} from '../../../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {makeGetAccountsCSVFileState} from '../../../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {
  contactsManagerClearFileAction,
  contactsManagerUploadAccountsCSVAction,
} from '../../../../../../../../../src/store/panels/contacts/contactsManager/file/contactsManagerFileStateActions';
import {ImportAccountsCSVDialog} from './importAccountsCSVDialog';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  shouldDisplayImportCSVInfoBanner: getShouldDisplayImportAccountsCSVInfoBanner,
  fileState: makeGetAccountsCSVFileState(),
  accountsImportJobs: getAccountsImportJobs,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  toggleShouldDisplayImportCSVInfoBanner: toggleShouldDisplayImportCSVInfoBannerAction,
  uploadAccountsCSV: contactsManagerUploadAccountsCSVAction,
  clearFile: contactsManagerClearFileAction,
  deleteJob: jobDeletedAction,
}));

export const ImportAccountsCSVDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    clearJobs: () => {
      batch(() => {
        stateProps.accountsImportJobs.forEach((importJob) => dispatchProps.deleteJob(importJob.id));
      });
    },
  }),
)(ImportAccountsCSVDialog);
